<template>
<ul class='list-unstyled'>
  <li v-for='branch in branches'>
    <div class='form-check custom-control custom-checkbox'>
      <input :id='"branch-" + branch.id' :value='branch.id' class='form-check-input custom-control-input' type='checkbox' :disabled='branchDisabled(branch)' v-model='value.branchIds[branch.id]'>
      <input :value='value.branchIds[branch.id] ? branch.id : ""' name='make_mail[branch_ids][]' type='hidden'>
      <label :for='"branch-" + branch.id' class='form-check-label custom-control-label'>
        支部: {{branch.name}}
      </label>
    </div>
    <ul class='ml-3 list-unstyled'>
      <li v-for='group in branch.groups'>
        <div class='form-check custom-control custom-checkbox'>
          <input :id='"group-" + group.id' :value='group.id' class='form-check-input custom-control-input' type='checkbox' :disabled='branchDisabled(branch)' v-model='value.groupIds[group.id]'>
          <input :value='value.groupIds[group.id] ? group.id : ""' name='make_mail[group_ids][]' type='hidden'>
          <label :for='"group-" + group.id' class='form-check-label custom-control-label'>
            グループ: {{group.name}}
          </label>
        </div>
      </li>
    </ul>
  </li>
</ul>
</template>
<script>
export default {
  props: ['branches', 'value', 'branchDisabled'],
}
</script>
